/**
 * Custom Hook for Facebook Login
 * Handles Facebook OAuth popup and Redux integration
 */

import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { loginWithFacebook } from "../services/facebookAuth";
import { socialLogin } from "../redux/slices/authSlice";

export const useFacebookLogin = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFacebookLogin = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      // Open Facebook login popup and get user data
      const facebookUserData = await loginWithFacebook();

      // Prepare data for backend API
      const socialLoginData = {
        provider: "facebook",
        provider_id: facebookUserData.provider_id,
        name: facebookUserData.name,
        email: facebookUserData.email,
        facebook_access_token: facebookUserData.accessToken,
        device_type: "web",
        // username: facebookUserData.email,
      };

      // Dispatch Redux action
      const result = await dispatch(socialLogin(socialLoginData)).unwrap();

      setIsLoading(false);
      return result;
    } catch (err) {
      console.error("Facebook login error:", err);
      setError(err.message || "Facebook login failed");
      setIsLoading(false);
      throw err;
    }
  }, [dispatch]);

  return {
    handleFacebookLogin,
    isLoading,
    error,
  };
};

export default useFacebookLogin;
